import {parseISO, startOfDay} from 'date-fns'
import {Rule} from 'antd/lib/form'

import {formatDate} from 'common/helpers'
import {FIELD_RULES} from 'common/constants'

export const isProjectRequest = (project: any): boolean =>
  project.status === 'pending' ||
  project.status === 'signed' ||
  project.status === 'declined'

export const getVariationDatesFieldRules = (maturityISO: string): Rule[] => [
  ...FIELD_RULES,
  () => ({
    validator(_: any, value: any) {
      if (!value) return Promise.reject()
      const maturityDate = parseISO(maturityISO)
      return startOfDay(value[1]) >= startOfDay(maturityDate)
        ? Promise.resolve()
        : Promise.reject(
            `maturity date can't be earlier than ${formatDate(maturityDate)}`
          )
    },
  }),
]

export const hasOverdueConditions = (conditions: any[]): boolean => {
  const today = new Date()
  return conditions?.some(
    (condition: any) =>
      !condition.checkedDate && today > parseISO(condition.date)
  )
}

export const isLVROverLimit = (project: any): boolean =>
  project.lvr > project.loanRequests[0].lvrMax

export const isScheduleItemRepayment = (item: any): boolean =>
  item.type === 'repayment' || item.type === 'application-fee'
